import { FOCUS_AUTO as b } from "../constants.js";
import { toArray as a } from "./array.js";
import { tabbables as m } from "./tabbables.js";
var u = m.join(","), d = "".concat(u, ", [data-focus-guard]"), f = function(o, e) {
  return a((o.shadowRoot || o).children).reduce(function(r, t) {
    return r.concat(t.matches(e ? d : u) ? [t] : [], f(t));
  }, []);
}, v = function(o, e) {
  var r;
  return o instanceof HTMLIFrameElement && (!((r = o.contentDocument) === null || r === void 0) && r.body) ? i([o.contentDocument.body], e) : [o];
}, i = function(o, e) {
  return o.reduce(function(r, t) {
    var c, l = f(t, e), s = (c = []).concat.apply(c, l.map(function(n) {
      return v(n, e);
    }));
    return r.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      s,
      // add if node is tabbable itself
      t.parentNode ? a(t.parentNode.querySelectorAll(u)).filter(function(n) {
        return n === t;
      }) : []
    );
  }, []);
}, g = function(o) {
  var e = o.querySelectorAll("[".concat(b, "]"));
  return a(e).map(function(r) {
    return i([r]);
  }).reduce(function(r, t) {
    return r.concat(t);
  }, []);
};
export {
  i as getFocusables,
  g as getParentAutofocusables
};
//# sourceMappingURL=tabUtils.js.map
